import { MessageSubscriber } from "@faire/messenger/MessageChannel/MessageChannel";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { webSocketUrls } from "@faire/retailer-visitor-shared/lib/webSocketUrls";
import { WebSocketChannelStore } from "@faire/retailer-visitor-shared/stores/WebSocketChannelStore";

export const initializeWebSocketChannels = (
  handleRetailerUserNotificationChannelMessage: MessageSubscriber
) => {
  if (isLoggedInRetailer()) {
    WebSocketChannelStore.get()
      .getOrInitChannel(webSocketUrls.retailerNotification())
      ?.subscribe(handleRetailerUserNotificationChannelMessage);
  }
};
